function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "83",
  viewBox: "0 0 100 83",
  focusable: "false"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a0842571-6694-4f2b-a31c-855e01333f7d",
  "data-name": "New Gradient Swatch 5",
  x1: "4.38",
  y1: ".6",
  x2: "90.89",
  y2: "68.13",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".89",
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#56488b"
}))), /*#__PURE__*/React.createElement("title", null, "graphic_spot_speech-bubble"), /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "bd0b6be5-d86b-4945-9b3d-d575c3527b78",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M96 .21H4a4 4 0 00-4 4v64a4 4 0 004 4h72L86.29 82.5a1 1 0 001.71-.71v-9.58h8a4 4 0 004-4v-64a4 4 0 00-4-4z",
  fill: "url(#a0842571-6694-4f2b-a31c-855e01333f7d)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "10.94",
  y: "18.21",
  width: "78",
  height: "4",
  rx: "2",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("rect", {
  x: "10.94",
  y: "34.21",
  width: "62",
  height: "4",
  rx: "2",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("rect", {
  x: "10.94",
  y: "50.21",
  width: "70",
  height: "4",
  rx: "2",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2"
})))));